var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconaPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 28H4.37499C2.51102 28 0.999988 26.4889 1 24.625L1.00013 4.37499C1.00014 2.51103 2.51118 1 4.37513 1H19.563C21.427 1 22.938 2.51104 22.938 4.37501V11.125M22.0938 22.0221V21.9332M28 22.0938C28 22.0938 26.5992 26.2277 22.0938 26.1555C17.5883 26.0833 16.1875 22.0938 16.1875 22.0938C16.1875 22.0938 17.5316 17.8877 22.0938 17.8877C26.6559 17.8877 28 22.0938 28 22.0938Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1485_5710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.01904 16.361V11H6.34215C6.82082 11 7.23566 11.0766 7.58029 11.2361C7.92493 11.3957 8.19298 11.6127 8.38445 11.9063C8.57591 12.1998 8.66526 12.5445 8.66526 12.9402C8.66526 13.3359 8.56953 13.6869 8.38445 13.9805C8.19298 14.2677 7.92493 14.491 7.58029 14.6506C7.23566 14.8102 6.82082 14.8867 6.34215 14.8867H4.70194L5.26995 14.3251V16.361H4.01904ZM5.26995 14.4591L4.70194 13.872H6.27195C6.6485 13.872 6.93569 13.789 7.12716 13.6295C7.31863 13.4635 7.42074 13.2338 7.42074 12.9402C7.42074 12.6466 7.32501 12.4168 7.12716 12.2573C6.93569 12.0977 6.6485 12.0148 6.27195 12.0148H4.70194L5.26995 11.4276V14.4655V14.4591Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62259 16.361V11H12.0606C12.6414 11 13.1583 11.1085 13.5987 11.3319C14.0454 11.5552 14.3901 11.868 14.639 12.2637C14.8879 12.6657 15.0155 13.138 15.0155 13.6741C15.0155 14.2102 14.8879 14.6889 14.639 15.0846C14.3901 15.4867 14.0391 15.7994 13.5987 16.0164C13.1519 16.2398 12.6414 16.3483 12.0606 16.3483H9.62259V16.361ZM10.8735 15.3526H11.9968C12.3542 15.3526 12.6669 15.2824 12.9286 15.1484C13.1902 15.0144 13.3945 14.8165 13.5412 14.5676C13.688 14.3123 13.7582 14.0188 13.7582 13.6805C13.7582 13.3423 13.688 13.0423 13.5412 12.7934C13.3945 12.5445 13.1902 12.353 12.9286 12.2126C12.6669 12.0722 12.3542 12.0084 11.9968 12.0084H10.8735V15.3463V15.3526Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1982 16.361H15.9473V11H20V11.9956H17.1982V16.361ZM17.1025 13.4125H19.6745V14.4081H17.1025V13.4125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1485_5710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.981,
    height: 5.36102,
    fill: "white",
    transform: "translate(4.01904 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaPdf);
export default __webpack_public_path__ + "static/media/icona_pdf.7a9e3b1217aa824d628b549ed078a12a.svg";
export { ForwardRef as ReactComponent };